import { createFileRoute } from '@tanstack/react-router'

import { ProductPresentation } from '../../../components/pages/backoffice/home/product-presentation.tsx'

export const Route = createFileRoute('/bo/products/')({
  component: function Component() {
    return <ProductPresentation />
  },
})
